<template>
  <van-popup
    position="bottom"
    :class="`base-popup-dialog ${safeBottomAreaClass}`"
    :overlay-class="`base-popup-dialog-overlay ${safeBottomAreaClass}`"
    v-bind="$attrs"
  >
    <slot></slot>
    <div v-if="isNeedSafeBottomArea && showFillBar" class="safe-bottom-area-box"></div>
  </van-popup>
</template>

<script setup lang="ts">
  import { Popup as VanPopup } from 'vant';
  import { isNeedSafeBottomArea } from '@shared/utils';
  const safeBottomAreaClass = isNeedSafeBottomArea ? 'safe-bottom-area' : '';
  defineProps({
    showFillBar: {
      type: Boolean,
      default: false,
    },
  });
</script>

<style lang="less">
  // 弹窗背景遮罩
  .base-popup-dialog-overlay.safe-bottom-area {
    bottom: var(--safe-bottom-area);
    height: calc(100vh - var(--safe-bottom-area));
  }

  // 弹窗
  .base-popup-dialog {
    box-sizing: border-box;
    overflow-y: hidden;
    font-size: 0.26rem;
    background: #f5f5f5;
    &.safe-bottom-area {
      bottom: var(--safe-bottom-area);
    }
  }

  .safe-bottom-area-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff !important;
    height: var(--safe-bottom-area);
  }
</style>
